const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve an avatar/photo URL coming from the backend. The backend stores
 * uploaded profile photos with a relative path (e.g. "/api/venue/photos/xyz.jpg")
 * so we prefix it with REACT_APP_BACKEND_URL when needed.
 */
export const resolveAvatarUrl = (url) => {
  if (!url) return null;
  if (typeof url !== 'string') return null;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  if (url.startsWith('/')) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
};

export default resolveAvatarUrl;
